export default "__VITE_ASSET__DYaoQU$a__"